module.exports = __webpack_public_path__ + "va.svg?2e6c8b3c8ed70da2215ee27105dad523";